import { render, staticRenderFns } from "./ToTop.vue?vue&type=template&id=47d7360b&scoped=true&"
import script from "./ToTop.vue?vue&type=script&lang=js&"
export * from "./ToTop.vue?vue&type=script&lang=js&"
import style0 from "./ToTop.vue?vue&type=style&index=0&id=47d7360b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7360b",
  null
  
)

export default component.exports